import React from "react";
import PropTypes from "prop-types";
import { default as ReactSelect } from "react-select";
import { height, width } from "@fortawesome/free-solid-svg-icons/fa0";
import { Placeholder, SingleValue } from "react-select/animated";
import { Transition } from "react-transition-group";

// const customStyles = {
//   control: (base, isFocused, isSelected) => ({
//     ...base,
//     // match with the menu
//     borderRadius: "0",
//     // Removes weird border around container
//     boxShadow: null,
//     // borderColor: "hsl(215deg 16% 47%)",
//     // // borderColor: isFocused ? 'rgb(225 29 72)': isSelected ? 'rgb(225 29 72)' : undefined, 

//   }),
//   menu: (base, isSelected, isFocused) => ({
//     ...base,
//     // override border radius to match the box
//     borderRadius: 0,
//     // kill the gap
//     marginTop: 0,
//     fontSize: "14px"

//   }),
//   option: (styles, { isFocused, isSelected, isUnchecked }) => ({
//     ...styles,
//     // background : isFocused ? 'rgba(255, 255, 255, 1)': isSelected ? 'rgba(255, 255, 255, 1)' : undefined,
//     background: isUnchecked ? 'rgba(255, 255, 255, 1)' : isSelected ? 'rgba(255, 255, 255, 1)' : undefined,
//     color: isSelected ? 'rgba(0, 0, 0, 1)' : undefined,
//     zIndex: 1,
//     fontSize: "14px"
//   }),
//   menuList: base => ({
//     ...base,
//     // kill the white space on first and last option
//     padding: 0,
//     fontSize: "14px"


//   })
// }

const MultiSelectDropdown = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderWidth: state.isFocused ? "none !important" : "none", // Custom border color on focus
      border: "none !important",
      padding: "0 8px", // Horizontal padding for content
      display: "flex", // Ensures proper alignment
      alignItems: "center", // Vertically centers the text
      boxSizing: "border-box",
      height: "37.6px !important", // Set fixed height for the control
      backgroundColor: "none !important",
      margin: "0",
      borderRadius: "6px",
      outline: state.isFocused ? "2px solid #2684ff !important " : "",
      '& .css-x6wzi3': {
        height: "38px",
        padding: "0",
        margin: "0",
      },
    }),
    indicatorSeparator: (base) => ({
      ...base,
      width: "0 !important", // Set the width to 0 to hide it
    }),
    menu: (base, isSelected, isFocused) => ({
      ...base,
      // override border radius to match the box
      borderRadius: "6px",
      fontSize: "14px",
      zIndex: "10",

    }),


    valueContainer: (base) => ({
      ...base,
      padding: "0", // Removes extra padding from the value container
      margin: "0",
      boxSizing: "border-box",
      height: "36px !important",
    }),
    container: (base, state) => ({
      ...base,
      borderRadius: "6px !important",
      border: "1px solid #ccc",
      height: state.isFocused ? "38px" : base.height,
      outline: state.isFocused ? "none !important" : "",

      '& .css-19bb58m': {
        height: "38px !important",
        margin: "0",
        padding: "0",
        marginTop: "-1px",
        boxSizing: "border-box",
        borderRadius: "6px !important",
        height: state.isFocused ? "38px !important" : base.height,
      },
      '& .css-1cfo1cf': {
        height: "38px !important",
        margin: "0",
        padding: "0",
        marginBottom: "2px"
      },
      '& .css-1jqq78o-placeholder': {
        marginBottom: "2px",
        padding: "0",
      },

    }),
    Placeholder: (base) => ({
      ...base,
      marginBottom: "2px"
    }),

    SingleValue: (base) => ({
      ...base,
      marginBottom: "2px",
      fontSize: "14px !important",

    }),

  };

  const customFilter = (option, inputValue) => {
    return option.label.toLowerCase().startsWith(inputValue.toLowerCase());
  };

  if (props.allowSelectAll) {
    return (
      <span
        className="d-inline-block custom-input text-sm "
        data-toggle="popover"
        data-trigger="focus"
        data-content="Please selecet account(s)"
      >
        <ReactSelect className="custom-checkbox-select text-sm "
          isDisabled={props.isDisabled}
          styles={customStyles}
          {...props}
          options={[props.allOption, ...props.options]}
          onChange={(selected) => {
            if (
              selected !== null &&
              selected.length > 0 &&
              selected[selected.length - 1].value === props.allOption.value
            ) {
              return props.onChange(props.options, props.drpIdentity);
            }
            return props.onChange(selected, props.drpIdentity);
          }}

        />
      </span>
    );
  }
  MultiSelectDropdown.defaultProps = {
    allOption: {
      label: "Select all",
      value: "*"
    },
    Option: {
      label: "Select",
      value: ""
    }

  };
  return <ReactSelect styles={customStyles}  {...props} filterOption={customFilter} />
};

MultiSelectDropdown.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
};

MultiSelectDropdown.defaultProps = {
  allOption: {
    label: "Select all",
    value: "*"
  },
  Option: {
    label: "Select",
    value: ""
  }

};

export default MultiSelectDropdown;
